import { get } from 'lodash';
import uri from 'urijs';
import { routesConf as routes } from './routesConf';

function getArgName(arg: RouteConfArg): string {
  return typeof arg === 'string' ? arg : arg.name;
}

function urlPattern(routeName: string): string {
  const route: RouteConf = routes[routeName];
  const baseUrl = get(route, 'baseUrl');

  if (route.args) {
    const params = route.args.reduce((acc, arg) => `${acc}/:${getArgName(arg)}`, '');
    return baseUrl + params;
  }

  return baseUrl;
}

function buildUrl(
  routeName: string,
  pathParams?: any | null | undefined,
  queryParams?: any | null | undefined,
) {
  const route = routes[routeName];
  let pathParamsSegment = [];
  let url = route.baseUrl;
  pathParams = pathParams || {};

  if (route.args) {
    pathParamsSegment = route.args.map((arg) => {
      if (typeof arg === 'string') {
        const param = get(pathParams, arg, null);

        if (param === null) {
          throw new Error(`This route requires a ${arg} parameter`);
        }

        return param;
      }

      const paramName = get(arg, 'name', undefined);
      const restrictions = get(arg, 'restrict', undefined);

      if (!paramName) {
        throw new Error(`The restricted argument for ${route.baseUrl} should have a name`);
      }

      if (!restrictions) {
        throw new Error(
          `The restricted argument for ${route.baseUrl} should have a restrictions object`,
        );
      }

      const paramValue = get(pathParams, paramName, null);

      if (paramValue === null) {
        throw new Error(`This route requires a restricted ${paramName} parameter`);
      }

      const isValidParam = Object.keys(restrictions).some(
        (restrictionName) => paramValue === restrictions[restrictionName],
      );

      if (!isValidParam) {
        throw new Error(`The ${paramName} does not match the restrictions`);
      }

      return paramValue;
    });
  }

  url = pathParamsSegment.length > 0 ? `${url}/${pathParamsSegment.join('/')}` : url;
  url = Object.keys(queryParams || {}).length ? `${url}?${uri.buildQuery(queryParams)}` : url;

  if (pathParams) {
    Object.entries(pathParams).forEach(([key, value]) => {
      if (url.includes(':' + key) && (typeof value === 'string' || typeof value === 'number')) {
        url = url.replace(':' + key, String(value));
      }
    });
  }

  return url;
}

export { urlPattern, buildUrl };
